import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">

                                            <p>It is necessary to understand the factors that can make a
                                                difference in terms of impact on a
                                                particular person and/or situation. This means that the
                                                characteristics of any given situation need
                                                to be attended to so that you can adapt your style in line with
                                                that need. For example, in a
                                                particular situation are you able to identify what is working
                                                and what is not? Gaining a better
                                                understanding of what your impact actually is will enable you to
                                                compare this with your intended
                                                impact. This will enable you to realign what you are intending
                                                your impact to be and what the
                                                reality is.</p>
                                            <div className="border_subtitle">Stage 3 – Act</div>
                                            <div className="paraspace2"><p>See what happens. Your impact is
                                                affected by your desire and ability to read the person. There
                                                are a number of factors that you should attend to:</p></div>
                                            <ul className="greenbullet-list peoplelinehight">
                                                <li>Ensure you are adopting an open, positive body language –
                                                    smiling and nodding helps to show understanding.
                                                </li>
                                                <li>Ask questions to clarify your understanding.</li>
                                                <li>Summarise statements to check your understanding as this
                                                    will encourage the individual to feel as though they are
                                                    being listened to and that you are interested in their
                                                    thoughts and ideas.
                                                </li>
                                                <li>Use this impact tool to develop your impact to enable you to
                                                    influence, motivate, inspire and persuade others.
                                                </li>
                                                <li className="list-bottom-pad">Adapt your style when
                                                    interacting with different people and situations to ensure
                                                    you have maximum impact. This can be based on the desired
                                                    outcomes and the style that you feel will be most
                                                    influential on them. This means that your style is fluid. If
                                                    you re-evaluate the style you are using you can adjust it if
                                                    it is not having the desired outcome.
                                                </li>
                                            </ul>


                                            <div className="border_subtitle" style={{paddingTop:'15px'}}>Stage 4 –
                                                Evaluation
                                            </div>
                                            <div className="paraspace2"><p>There is a need to reflect upon a
                                                situation during, as well as after. Initially this will need to
                                                occur
                                                consciously; however, later this will become easier and more
                                                like second nature for you. This will
                                                require you to assess:</p></div>
                                            <ul className="greenbullet-list peoplelinehight">
                                                <li>Why did you choose that particular method in that situation
                                                    or with that person?
                                                </li>
                                                <li>Did you achieve what you wanted to in this situation/with
                                                    this person?
                                                </li>
                                                <li className="list-bottom-pad">Did you get feedback about your
                                                    impact during and after the transaction?
                                                </li>


                                            </ul>

                                            <p>These questions will help you to identify the key elements that
                                                made, or could have made, a
                                                positive impact. You could have a more positive impact by
                                                evaluating and consciously choosing to
                                                use key elements that would help you improve your impact. This
                                                stage feeds back into the act
                                                stage. You can try to adapt your style to modify your approach
                                                and make a more positive impact.</p>
                                            <div className="paraspace2"><p>After a period of time you can
                                                re-evaluate an interaction where you were attending to your
                                                impact
                                                to help you to explore what went well and what you could have
                                                done better. Ask yourself:</p></div>

                                            <ul className="greenbullet-list peoplelinehight">
                                                <li>What were the barriers and challenges in that situation to
                                                    create a positive impact?
                                                </li>
                                                <li>Do other people find these factors to be barriers or
                                                    challenges?
                                                </li>
                                                <li>How could you overcome these barriers/how do others overcome
                                                    these barriers or challenges?
                                                </li>
                                                <li>Are you having as much impact as your skill level suggests
                                                    you might?
                                                </li>
                                                <li className="list-bottom-pad">If not, why not? What could be
                                                    stopping you from having a positive impact?
                                                </li>


                                            </ul>

                                            <p>Feedback is essential to help you to understand and make changes
                                                to your preferred style to
                                                better suit others or the task in hand. If you ask for feedback
                                                to help improve your impact style,
                                                then this is initially most useful when gained from situations
                                                when no conflict was involved.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}